var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowChartUp = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.914 6.0143L5.04232 17.8756C4.74291 18.1748 4.74291 18.66 5.04232 18.9592V18.9592C5.34137 19.258 5.82593 19.258 6.12498 18.9592L17.9844 7.11015V11.2421C17.9844 11.6606 18.3237 11.9999 18.7422 11.9999V11.9999C19.1608 11.9999 19.5001 11.6606 19.5001 11.2421V5.24995C19.5001 4.83574 19.1643 4.49995 18.7501 4.49995H12.7638C12.3456 4.49995 12.0066 4.83895 12.0066 5.25713V5.25713C12.0066 5.6753 12.3456 6.0143 12.7638 6.0143H16.914Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowChartUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-chart-up.0012f46809d3bf10646aa6f6098af91d.svg";